import type { ReactNode } from 'react';

export const symbol_north_west: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-658v264q0 13-8.5 21.5T230-364q-13 0-21.5-8.5T200-394v-336q0-13 8.5-21.5T230-760h336q13 0 21.5 8.5T596-730q0 13-8.5 21.5T566-700H302l477 477q9 9 9 21t-9 21q-9 9-21 9t-21-9L260-658Z"
		/>
	</svg>
);
